"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AsyncMeetingsContainer = AsyncMeetingsContainer;
exports.AsyncSettingsContainer = AsyncSettingsContainer;
exports.AsyncIntegrationContainer = AsyncIntegrationContainer;

var _react = _interopRequireDefault(require("react"));

var _Loadable = _interopRequireDefault(require("UIComponents/decorators/Loadable"));

var _UILoadingSpinner = _interopRequireDefault(require("UIComponents/loading/UILoadingSpinner"));

var MeetingsContainer = (0, _Loadable.default)({
  loader: function loader() {
    return import('./containers/MeetingsContainer'
    /* webpackChunkName: "chunk-sales-meetings" */
    );
  },
  LoadingComponent: function LoadingComponent() {
    return _react.default.createElement(_UILoadingSpinner.default, {
      grow: true,
      minHeight: 200
    });
  }
});

function AsyncMeetingsContainer(props) {
  return _react.default.createElement(MeetingsContainer, props);
}

var SettingsContainer = (0, _Loadable.default)({
  loader: function loader() {
    return import('./containers/SettingsContainer'
    /* webpackChunkName: "chunk-sales-meetings" */
    );
  },
  LoadingComponent: function LoadingComponent() {
    return _react.default.createElement(_UILoadingSpinner.default, {
      grow: true,
      minHeight: 200
    });
  }
});

function AsyncSettingsContainer(props) {
  return _react.default.createElement(SettingsContainer, props);
}

var IntegrationContainer = (0, _Loadable.default)({
  loader: function loader() {
    return import('./containers/IntegrationContainer'
    /* webpackChunkName: "chunk-sales-meetings" */
    );
  },
  LoadingComponent: function LoadingComponent() {
    return _react.default.createElement(_UILoadingSpinner.default, {
      grow: true,
      minHeight: 200
    });
  }
});

function AsyncIntegrationContainer(props) {
  return _react.default.createElement(IntegrationContainer, props);
}